import { MoreVertical, Plus, X } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

// The ••• per-person popover: "Add a project" + "Remove all access". The
// prototype's "Message {first}" item is deliberately OMITTED (D4 — no
// customer<->manager thread mechanism exists; §11). Built on the DS DropdownMenu
// primitive: Radix owns open state, outside-click + Escape dismissal, and the
// menu/menuitem ARIA — the hand-rolled versions are gone (Hallmark §5d).
export default function PersonMenu({ onAddProject, onRemoveAll }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="More actions"
          className="grid size-[34px] shrink-0 place-items-center rounded-[9px] border border-border bg-card text-muted-foreground transition-colors hover:bg-secondary"
        >
          <MoreVertical className="size-[17px]" strokeWidth={2} />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        sideOffset={6}
        className="min-w-[188px] rounded-[12px] border-line-2 bg-card p-1.5 shadow-[0_18px_40px_-16px_rgba(0,0,0,0.3)]"
      >
        <DropdownMenuItem
          onSelect={onAddProject}
          className="gap-2.5 rounded-lg px-2.5 py-[9px] text-[12.5px] font-medium text-muted-foreground focus:bg-secondary focus:text-foreground"
        >
          <Plus className="size-[15px] text-ink-3" strokeWidth={1.9} />
          Add a project
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={onRemoveAll}
          className="gap-2.5 rounded-lg px-2.5 py-[9px] text-[12.5px] font-medium text-primary focus:bg-[var(--red-soft)] focus:text-primary"
        >
          <X className="size-[15px] text-primary" strokeWidth={1.9} />
          Remove all access
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
